import dayjs, { Dayjs } from "dayjs";

export class SubmittalFilterInfo {
    approvalDate: Dayjs | null;
    currentRevision: boolean;
    description: string | null;
    label: string | null;
    leadTime: number | null;
    needsReviseAndResubmit: boolean;
    requiredOnJobsite: Dayjs | null;
    specNumber: string | null;
    status: string | null;
    submitDate: Dayjs | null;
    submittalNumber: string | null;
    submittalType: string | null;
    title: string | null;
    vendorUniqueId: string | null;
    sortBy: string | null;
    sortDirection: "asc" | "desc";
    page: number | null;
    pageSize: number | null;
    textSearch: string | null;
    connected: boolean | null;
    constructor() {
        this.approvalDate = null;
        this.currentRevision = false;
        this.description = null;
        this.label = null;
        this.leadTime = null;
        this.needsReviseAndResubmit = false;
        this.requiredOnJobsite = null;
        this.specNumber = null;
        this.status = null;
        this.submitDate = null;
        this.submittalNumber = null;
        this.submittalType = null;
        this.title = null;
        this.vendorUniqueId = null;
        this.sortBy = "approval_date";
        this.sortDirection = "asc";
        this.page = null;
        this.pageSize = 50;
        this.textSearch = null;
        this.connected = null;
    }

    toApiObject() {
        return {
            approval_date: this.approvalDate ? this.approvalDate.toISOString() : null,
            current_revision: this.currentRevision,
            description: this.description,
            label: this.label,
            lead_time: this.leadTime,
            needs_revise_and_resubmit: this.needsReviseAndResubmit,
            required_on_jobsite: this.requiredOnJobsite ? this.requiredOnJobsite.toISOString() : null,
            spec_number: this.specNumber,
            status: this.status,
            submit_date: this.submitDate ? this.submitDate.toISOString() : null,
            submittal_number: this.submittalNumber,
            submittal_type: this.submittalType,
            title: this.title,
            vendor_unique_id: this.vendorUniqueId,
            sort_by: this.sortBy,
            sort_direction: this.sortDirection,
            page: this.page,
            page_size: this.pageSize,
            text_search: this.textSearch,
            connected: this.connected,
        };
    }
    static fromApiObject(obj: any, timezone: string): SubmittalFilterInfo {
        const filter = new SubmittalFilterInfo();
        filter.approvalDate = obj.approval_date ? dayjs(obj.approval_date).tz(timezone) : null;
        filter.currentRevision = obj.current_revision;
        filter.description = obj.description;
        filter.label = obj.label;
        filter.leadTime = obj.lead_time;
        filter.needsReviseAndResubmit = obj.needs_revise_and_resubmit;
        filter.requiredOnJobsite = obj.required_on_jobsite ? dayjs(obj.required_on_jobsite).tz(timezone) : null;
        filter.specNumber = obj.spec_number;
        filter.status = obj.status;
        filter.submitDate = obj.submit_date ? dayjs(obj.submit_date) : null;
        filter.submittalNumber = obj.submittal_number;
        filter.submittalType = obj.submittal_type;
        filter.title = obj.title;
        filter.vendorUniqueId = obj.vendor_unique_id;
        filter.sortBy = obj.sort_by;
        filter.sortDirection = obj.sort_direction;
        filter.page = obj.page;
        filter.pageSize = obj.page_size;
        filter.textSearch = obj.text_search;
        filter.connected = obj.connected;
        return filter;
    }

    toUrlSearchParams() {
        const params = new URLSearchParams();
        if (this.title) {
            params.set("title", this.title);
        }
        if (this.approvalDate) {
            params.set("approval_date", this.approvalDate.toISOString());
        }
        if (this.currentRevision) {
            params.set("current_revision", this.currentRevision.toString());
        }
        if (this.description) {
            params.set("description", this.description);
        }
        if (this.label) {
            params.set("label", this.label);
        }
        if (this.leadTime) {
            params.set("lead_time", this.leadTime.toString());
        }
        if (this.needsReviseAndResubmit) {
            params.set("needs_revise_and_resubmit", this.needsReviseAndResubmit.toString());
        }
        if (this.requiredOnJobsite) {
            params.set("required_on_jobsite", this.requiredOnJobsite.toISOString());
        }
        if (this.specNumber) {
            params.set("spec_number", this.specNumber);
        }
        if (this.status) {
            params.set("status", this.status);
        }
        if (this.submitDate) {
            params.set("submit_date", this.submitDate.toISOString());
        }
        if (this.submittalNumber) {
            params.set("submittal_number", this.submittalNumber);
        }
        if (this.submittalType) {
            params.set("submittal_type", this.submittalType);
        }
        if (this.vendorUniqueId) {
            params.set("vendor_unique_id", this.vendorUniqueId);
        }
        if (this.sortBy) {
            params.set("sort_by", columnFieldsToSortableNames(this.sortBy));
        }
        if (this.sortDirection) {
            params.set("sort_direction", this.sortDirection);
        }
        if (this.page !== undefined && this.page !== null) {
            params.set("page", this.page.toString());
        }
        if (this.pageSize !== undefined && this.pageSize !== null) {
            params.set("page_size", this.pageSize.toString());
        }
        if (this.textSearch) {
            params.set("text_search", this.textSearch);
        }
        if (this.connected) {
            params.set("connected", this.connected.toString());
        }
        return params;
    }
}
export const columnFieldsToSortableNames = (columnField: string) => {
    switch (columnField) {
        case "materialsSubmittals":
            return "materials_submittals";
        case "latestResponse":
            return "latest_response";
        default:
            return columnField;
    }
};
